import { ComponentType } from 'react';
import { IconCollection } from '../icon/IconCollection';
import { IconGallery } from '../icon/IconGallery';
import { IconVideo } from '../icon/IconVideo';
import type { PostUI } from './types';
import type { IconProps } from '../icon/createIconComponent';

export const getContentIcon = (
    content: PostUI['content'] = [],
    type?: string,
): ComponentType<IconProps> | null => {
    if (type === 'collection') {
        return IconCollection;
    }

    const [firstSlide] = content;

    if (content.length > 1) {
        return IconGallery;
    }

    if (firstSlide && firstSlide?.type === 'video') {
        return IconVideo;
    }

    return null;
};
